import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { LocationService } from 'src/app/services/location.service';

@Component({
  selector: 'app-forgot-pasword',
  templateUrl: './forgot-pasword.component.html',
  styleUrls: ['./forgot-pasword.component.scss'],
})
export class ForgotPaswordComponent  implements OnInit {

  form = new FormGroup({
    email: new FormControl('', [Validators.email, Validators.required]),
  })

  constructor(private locationService: LocationService,
    public router: Router,
    private authService: AuthService,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.titleService.setTitle($localize`Forgot password`)
  }

  send() {
    this.authService.forgotPassword(this.form.controls.email.value).subscribe(_data => {
      this.form.controls.email.setValue('')
      alert($localize`An email has been sent to your address. Also check your spam folder.`)
    })
  }
}


